import React from 'react';
import './Separator.styl';

function Separator(props) {
  return <div className="separator"></div>;
}

export { Separator };
